import { GET_COMPANY_INFO_REQUEST, GET_COMPANY_INFO_SUCCESS, GET_COMPANY_INFO_FAILURE } from "../../actions";
const initialState = {
    map: {},
    loadingIds: {},
    failedIds: {},
};
const getCompanyInfoReducer = (state = initialState, action) => {
    var _a;
    switch (action.type) {
        case GET_COMPANY_INFO_REQUEST: {
            const loadingIds = Object.assign({}, state.loadingIds);
            action.payload.companyIds.forEach((id) => (loadingIds[id] = true));
            return Object.assign(Object.assign({}, state), { loadingIds });
        }
        case GET_COMPANY_INFO_SUCCESS: {
            const map = Object.assign({}, state.map);
            const loadingIds = Object.assign({}, state.loadingIds);
            ((_a = action.payload.data) !== null && _a !== void 0 ? _a : []).forEach((company) => {
                map[company.tenantId] = company;
                loadingIds[company.tenantId] = false;
            });
            return Object.assign(Object.assign({}, state), { map, loadingIds });
        }
        case GET_COMPANY_INFO_FAILURE: {
            const loadingIds = Object.assign({}, state.loadingIds);
            const failedIds = Object.assign({}, state.failedIds);
            action.payload.companyIds.forEach((id) => {
                loadingIds[id] = false;
                failedIds[id] = true;
            });
            return Object.assign(Object.assign({}, state), { loadingIds, failedIds });
        }
        default:
            return state;
    }
};
export default getCompanyInfoReducer;
